import React from "react";
import CountUp from "react-countup";

import {
  Flex,
  FlexProps,
  IconCart,
  IconClock,
  IconEye,
  IconFlame,
  Text,
} from "@catchoftheday/cg-components";
import { TopicStats } from "@catchoftheday/state";

const countUpProps = {
  useEasing: true,
  preserveValue: true,
  duration: 3,
};

type SocialUrgencyProps = {
  bordered?: boolean;
  stats: TopicStats | null;
  containerProps?: FlexProps;
};

export const SocialUrgency = ({
  bordered = true,
  stats,
  containerProps,
}: SocialUrgencyProps) => {
  if (!stats) {
    return null;
  }

  const { quantityRemaining, quantitySold, viewerCount, viewerEffect } = stats;

  if (!quantityRemaining && !viewerCount && !quantitySold) {
    return null;
  }

  return (
    <Flex
      m={{ xs: "20px 0 0", lg: "0 0 10px" }}
      justifyContent={{ xs: "center", lg: "flex-start" }}
      {...containerProps}
    >
      {quantityRemaining && (
        <Flex
          mr={2}
          border={bordered ? "1px solid" : "none"}
          borderColor="secondary"
          height="24px"
          alignItems="center"
          px={bordered ? 3 : 0}
        >
          <IconClock
            title="Clock Icon"
            role="img"
            width="auto"
            height="16px"
            color="secondary"
          />
          <Text m={0} ml="4px" fontSize="12px" color="secondary">
            <CountUp
              prefix="HURRY! "
              end={quantityRemaining}
              suffix=" LEFT"
              {...countUpProps}
            />
          </Text>
        </Flex>
      )}

      {viewerCount && (
        <Flex
          mr={2}
          color={viewerEffect === "HOT" ? "error" : "secondary"}
          border={bordered ? "1px solid" : "none"}
          borderColor="currentColor"
          height="24px"
          alignItems="center"
          px={bordered ? 3 : 0}
        >
          {viewerEffect === "HOT" ? (
            <IconFlame
              title="Flame Icon"
              role="img"
              width="auto"
              height="16px"
              color="currentColor"
            />
          ) : (
            <IconEye
              title="Eye Icon"
              role="img"
              width="auto"
              height="16px"
              color="currentColor"
            />
          )}
          <Text m={0} ml="4px" fontSize="12px" color="currentColor">
            <CountUp
              end={viewerCount}
              suffix=" currently viewing"
              {...countUpProps}
            />
          </Text>
        </Flex>
      )}

      {quantitySold && (
        <Flex
          mr={2}
          border={bordered ? "1px solid" : "none"}
          borderColor="secondary"
          height="24px"
          alignItems="center"
          px={bordered ? 3 : 0}
        >
          <IconCart
            title="Cart Icon"
            role="img"
            width="auto"
            height="16px"
            color="secondary"
          />
          <Text m={0} ml="4px" fontSize="12px" color="secondary">
            <CountUp
              end={quantitySold}
              suffix=" bought so far"
              {...countUpProps}
            />
          </Text>
        </Flex>
      )}
    </Flex>
  );
};
